export function createBridgeAction(apiCall) {
  return function(...args) {
    return {
      bridge: {
        apiCall,
        args,
      },
    };
  };
}
